export default __webpack_public_path__ + "830cd911fa450a3e75956dd61e68da1f.svg";